/**
 * relivConferenceReportDirective
 */
angular.module('relivConference').directive(
    'relivConferenceReportDirective',
    [
        'relivConferenceReportService',
        function (
            relivConferenceReportService
        ) {
            var link = function (scope, element, attrs) {

                scope.conferences = [];

                scope.selectedConference = null;

                scope.report = {};

                /**
                 *
                 * @param conference
                 */
                scope.onSelectConference = function (conference) {
                    scope.selectedConference = conference;
                    relivConferenceReportService.getConferenceReport(
                        conference.id,
                        onGetConferenceReportSuccess,
                        onGetConferenceReportError
                    );
                };

                var onGetConferenceReportSuccess = function (report) {
                    scope.report = report;
                };

                var onGetConferenceReportError = function (report) {
                    console.error('onGetConferenceReportError');
                };

                var onGetConferencesSuccess = function (conferences) {
                    scope.conferences = conferences;
                    var confCount = conferences.length;
                    if (confCount > 0) {
                        scope.onSelectConference(conferences[confCount - 1]);
                    }
                };

                /**
                 * onGetConferencesError
                 * @param conferences
                 */
                var onGetConferencesError = function (conferences) {
                    console.error('onGetConferencesError');
                };

                /**
                 * init
                 */
                var init = function () {
                    relivConferenceReportService.getConferences(
                        onGetConferencesSuccess,
                        onGetConferencesError
                    );
                };

                init();
            };

            return {
                scope: {
                    relivConferenceRibbonsDirective: '=',
                },
                link: link,
                template: require('./reliv-conference-report-directive.html'),
            };
        },
    ]
);
